/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BackgroundElement from '../components/BackgroundElement';
import BannerImage from '../components/BannerImage';
import BannerLinkButton from '../components/BannerLinkButton';
import BannerSubtitle from '../components/BannerSubtitle';
import BannerTeaser from '../components/BannerTeaser';
import BannerTitle from '../components/BannerTitle';
import Disruptor from '../components/Disruptor';
import LinkWrapper from '../components/LinkWrapper';
import AbstractLayout from './AbstractLayout';

export default class GeneralCampaign extends AbstractLayout {
	get key() {
		return 'general_campaign';
	}

	content() {
		const { banner } = this.attrs;

		return (
			<LinkWrapper banner={banner}>
				<div className="Banner-content">
					<div className="BannerImageWrapper">
						<BannerImage banner={banner} />
					</div>

					<div className="BannerContentContainer">
						<BannerTitle banner={banner} />
						<BannerSubtitle banner={banner} />
						<BannerTeaser banner={banner} />
						<Disruptor banner={banner} />
						<BannerLinkButton banner={banner} />
					</div>

					<BackgroundElement banner={banner} />
				</div>
			</LinkWrapper>
		);
	}
}
